import { request } from '@/util/http'

export const getList0 = (current, size, params) => {
  return request({
    url: '/health/guidanceSleepDiaryKnowledge/list0',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getList1 = (current, size, params) => {
  return request({
    url: '/health/guidanceSleepDiaryKnowledge/list1',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/guidanceSleepDiaryKnowledge/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/guidanceSleepDiaryKnowledge/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/guidanceSleepDiaryKnowledge/submit',
    method: 'post',
    data: row
  })
}

